import { PayloadRequest } from "src/redux/broker_configuration/state";

let currentAbortController: AbortController | null = null;

export const getBrokerProperties = async (payload: PayloadRequest, token: string) => {
    // Cancelar la solicitud anterior si existe
    if (currentAbortController) {
        currentAbortController.abort();
    }
    // Crear un nuevo AbortController para esta solicitud
    currentAbortController = new AbortController();

    delete payload.filter;
    const queryString = new URLSearchParams(payload as Record<string, string>).toString();
    const url = `${process.env.REACT_APP_GLOBAL_USERS}get_properties_brokers?${queryString}&country=MX`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': '*',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_GLOBAL_USERS_XAPIKEY
        },
        signal: currentAbortController.signal,
    };
    const urlRequest = `${url}`;
    try {
        const res = await fetch(urlRequest, requestOptions);
        return res?.json();
    } catch (error: any) {
        if (error.name === 'AbortError') {
            return {
                error: error.name
            };
        }
        throw error;
    }
};

export const saveBrokerConfiguration = async (
    payload: PayloadRequest,
    token: string,
) => {
    const url = `${process.env.REACT_APP_GLOBAL_USERS}save_broker_configuration?country=MX`;
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_GLOBAL_USERS_XAPIKEY
        },
        body: JSON.stringify(payload),
    };
    const res = await fetch(url, requestOptions);
    return res.json();
};

export const getBrokerConfiguration = async (
    users_id: string,
    token: string
) => {
    const url = `${process.env.REACT_APP_GLOBAL_USERS}get_broker_configuration?country=MX&users_id=${users_id}`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_GLOBAL_USERS_XAPIKEY
        },
    };
    const res = await fetch(url, requestOptions);
    return res.json();
};

export const getBrokerAnalizis = async (
    payload: PayloadRequest,
    token: string
) => {
    const queryString = new URLSearchParams(payload as Record<string, string>).toString();
    const url = `${process.env.REACT_APP_GLOBAL_USERS}analyze_brokers_orphans?${queryString}&country=MX`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_GLOBAL_USERS_XAPIKEY
        },
    };
    try{
        const res = await fetch(url, requestOptions);
        return res.json();
    }catch(error){
        throw new Error(`Failed to fetch broker analysis: ${error instanceof Error ? error.message : String(error)}`);
    }
};

